import ajax from '../http/ajax'

/**
 * 获取推荐门店列表
 * @param {*} params 参数
 * @return 略
 */
export const getRecommendStoreList = params => {
    return ajax.get('getRecommendStoreList', params)
}
